// The web app's confirmation before VERA sends, books or creates anything in Microsoft 365.
// VERA.exe shows a Windows confirmation instead (apps/desktop/src/graph.ts); both show the same words.
import { useEffect, useState } from "react";
import { Orb } from "./ui";
import { L } from "../lib/i18n";

type Ask = { message: string; detail: string; answer: (yes: boolean) => void };
let show: ((a: Ask) => void) | null = null;

/** Asks the person in the page. Resolves false if nobody can be asked. */
export function confirmInPage(message: string, detail: string): Promise<boolean> {
  return new Promise((resolve) => (show ? show({ message, detail, answer: resolve }) : resolve(false)));
}

export function ConfirmHost() {
  const [ask, setAsk] = useState<Ask | null>(null);
  useEffect(() => {
    show = (a) => setAsk((current) => { current?.answer(false); return a; });
    return () => { show = null; };
  }, []);
  if (!ask) return null;
  const done = (yes: boolean) => { ask.answer(yes); setAsk(null); };
  return (
    <div className="quick-back" onKeyDown={(e) => { if (e.key === "Escape") done(false); }}>
      <div className="card quick" role="alertdialog" aria-modal="true" aria-labelledby="confirm-title" style={{ maxWidth: 520 }}>
        <div className="row" style={{ gap: 10, flexWrap: "nowrap" }}><Orb size={28} mode="breathe" /><h2 id="confirm-title" style={{ fontSize: 18 }}>{ask.message}</h2></div>
        <p className="mute" style={{ whiteSpace: "pre-wrap", fontSize: 13.5, maxHeight: "50vh", overflow: "auto" }}>{ask.detail}</p>
        <div className="row" style={{ justifyContent: "flex-end", gap: 8 }}>
          <button className="btn" onClick={() => done(false)}>{L("Cancel", "Anulo")}</button>
          <button className="btn primary" autoFocus onClick={() => done(true)}>{L("Yes", "Po")}</button>
        </div>
      </div>
    </div>
  );
}
